module.exports = __webpack_public_path__ + "img/jr.fc3631d8.png";